// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header } from 'clark-styles';
import { postTutorResetPasswordEmail } from 'actions/tutor';

import PasswordForm from 'containers/password-form';
import Wrapper from 'components/shared/wrapper';
import Layout from 'components/shared/layout';

const mapStateToProps = ({
  form: { password: forgotPasswordForm },
  application: { flash, isLoading },
}) => ({
  forgotPasswordForm,
  flash,
  isLoading,
});

const mapDispatchToProps = {
  dispatchPostTutorResetPasswordEmail: postTutorResetPasswordEmail,
};

class ForgotPassword extends Component<*, void> {
  handleClick = () => {
    const { forgotPasswordForm, dispatchPostTutorResetPasswordEmail } = this.props;
    const { values } = forgotPasswordForm;

    dispatchPostTutorResetPasswordEmail({
      data: {
        attributes: {
          email: values.email,
        },
      },
    });
  };

  render() {
    const { isLoading, flash } = this.props;
    return (
      <Wrapper hasFlash={!!flash}>
        <Header />
        <Layout>
          <PasswordForm handleClick={this.handleClick} controlledLoading={isLoading} />
        </Layout>
      </Wrapper>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/screens/forgot-password/index.js